import {Injectable} from '@angular/core';
import {ServiceModule} from '../../../service.module';
import {HttpService} from "../http-service/http.service";
import {Observable} from "rxjs";
import {
    GlobalAccountModel
} from "../../../../core/models/cis/GlobalAccount.model";
import {SubaccountModel} from "../../../../core/models/cis/Subaccount.model";

@Injectable({providedIn: ServiceModule})
export class CisService {
    constructor(private httpService: HttpService<any>) {
    }

    getGlobalAccounts(landscape: string): Observable<GlobalAccountModel[]> {
        return this.httpService.get(`/api/automation/btp/ga?landscape=${landscape}`);
    }
    getSubaccounts(subdomain: string, landscape: string): Observable<SubaccountModel[]> {
        return this.httpService.get(`/api/automation/btp/ga/${subdomain}/subaccount?landscape=${landscape}`);
    }
}
